import React, { useEffect } from "react";
import {
  Tab,
  Icon,
  HStack,
  useColorModeValue as mode,
  useDisclosure,
  Avatar,
  Text,
  IconButton,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import { SmallCloseIcon } from "@chakra-ui/icons";

// Components
import { ConfirmPopup } from "components/popups/confirmPopup";

// Utils
import { removeProfilePosts } from "controllers/mentions";
import { updateUser } from "utils/sessionHelper";


const ProfileTab = ({ profile, session, account, onRemoving }) => {
  const { isOpen: isRemovingModalOpen, onOpen: onRemovingModalOpen, onClose: onRemovingModalClose } = useDisclosure()
  const [isRemoving, setIsRemoving] = React.useState<boolean>(false);

  const removeProfile = async () => {
    setIsRemoving(true);
    try {
      await updateUser(session, { mentionsProfiles: account.mentionsProfiles.filter((mentionsProfile) => mentionsProfile.id !== profile.id) });
      console.log("Removing profile", profile.id)
      await removeProfilePosts(account.id, profile.id, session);
      onRemoving();
      toast.success("Profile removed from @mentions");
    }
    catch (e) {
      toast.error("Something went wrong");
    }
    setIsRemoving(false);
  }
  return (
    <Tab
      py={2}
      px={4}
    >
      <HStack spacing={2}>
        <Avatar name={profile.name} src={profile.image} size="xs" />
        <Text as="span" fontWeight="semibold">{profile.name}</Text>
        <IconButton aria-label="Remove profile" icon={<Icon as={SmallCloseIcon} />} size="xs" variant="ghost" minW="initial" onClick={onRemovingModalOpen} />
      </HStack>

      <ConfirmPopup
        isOpen={isRemovingModalOpen}
        onClose={onRemovingModalClose}
        title="Remove account from list"
        allowClickBackground={true}
        body={
          `Are you sure you want to remove ${profile.name} from @metions?`
        }
        callback={removeProfile}
        ctaProps={
          { isLoading: isRemoving, loadingText: "Removing" }
        }
      />
    </Tab>
  )
}
export default ProfileTab;